// @flow

import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

// Actions
import { setClientInfo } from "@src/actions";

import { Button, Flex, Text, TextInput, Popover } from "@src/common";
import AccountLinks from "@src/common/AccountLinks";
import SelectField from "@src/common/muiComponents/SelectField";

// Material-UI components
import MenuItem from "material-ui/MenuItem";
import Checkbox from "material-ui/Checkbox";

// Mui Checkbox style
import { muiLabelStyle } from "@src/common/theme";

export const INITIAL_ASSESSMENT = "initial";
const REASSESSMENT = "re";

const ErrorText = styled(Text)`
  color: red;
`;

type State = {
  name: string,
  id: string,
  careType: string
};

class Landing extends React.Component {
  state: State = {
    name: "",
    id: ""
  };

  handleNext = () => {
    let error = false;

    if (!this.state.assessmentType) {
      error = true;
      this.setState({
        assessmentTypeError: true,
        assessmentTypeErrorMsg: (
          <ErrorText size="5">Please choose an<br />assessment type</ErrorText>
        )
      });
    }

    if (!this.state.careType) {
      error = true;
      this.setState({
        careTypeError: true,
        careTypeErrorMsg: (
          <ErrorText size="5">
            Please choose a<br />care type before starting
          </ErrorText>
        )
      });
    }

    if (!error) {
      this.props.setClientInfo({
        name: this.state.name,
        id: this.state.id,
        careType: this.state.careType,
        assessmentType: this.state.assessmentType,
        showAssessment: true
      });
    }
  };

  render() {
    return (
      <Flex
        key="Landing"
        flexDirection="column"
        justifyContent="flex-start"
        paddingT={5}
        paddingB={5}
        style={{ minHeight: "calc(100vh - 60px)" }}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2"
              style={{ textAlign: "center" }}
            >
              <Text size={2} type="medium" color="maroon" marginV={3}>
                Violence Assessment Tool (VAT)
              </Text>
              <Text size={4} type="book" marginV={4}>
                The Violence Assessment Tool provides a snapshot of a client’s immediate risk of violence. The VAT was developed (as part of the
                {" "}
                <a
                  href="https://workplace-violence.ca/tools/individual-client-risk-assessment/"
                  target="blank"
                >
                  Individual Client Risk Assessment Tool
                </a>
                ) for employers and employees in the healthcare and emergency services sectors. It’s designed to help these care providers identify risk factors and levels associated with workplace violence. By conducting regular client-risk assessments, providers can apply control interventions that promote both employee and client safety, as well as ensure client-centred care.
              </Text>
              <Text size={4} type="book" marginV={4}>
                The VAT should be completed at first contact with a client, and on an ongoing basis depending on client population, individual client circumstances, and the employer’s operational policies.
              </Text>
              <div className="row">
                <div className="col-lg-7 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2">
                  <TextInput
                    placeholder="Client's Name"
                    marginV={5}
                    value={this.state.name}
                    onChange={e => this.setState({ name: e.target.value })}
                  />
                  <TextInput
                    placeholder="Identification #"
                    marginV={5}
                    value={this.state.id}
                    onChange={e => this.setState({ id: e.target.value })}
                  />
                  <Popover
                    active={this.state.careTypeError}
                    tooltipContent={this.state.careTypeErrorMsg}
                    placement="right"
                    borderColor="red"
                    trigger="controlled"
                    id="missingCareTypeTooltip"
                  >
                    <SelectField
                      value={this.state.careType}
                      onChange={(e, index, value) =>
                        this.setState({
                          careType: value,
                          careTypeError: false
                        })}
                      large
                      fullWidth
                      style={{ backgroundColor: "#fff" }}
                      hintText="Select Care Sector"
                    >
                      <MenuItem
                        value={"longterm"}
                        primaryText="Long Term Care (LTC)"
                      />
                      <MenuItem value={"acute"} primaryText="Acute Care" />
                      <MenuItem
                        value={"ems"}
                        primaryText="Emergency Medical Services (EMS)"
                      />
                      <MenuItem
                        value={"communitycare"}
                        primaryText="Community Care"
                      />
                    </SelectField>
                  </Popover>
                  <Popover
                    active={this.state.assessmentTypeError}
                    tooltipContent={this.state.assessmentTypeErrorMsg}
                    placement="left"
                    borderColor="red"
                    trigger="controlled"
                    id="missingAssessmentTypeTooltip"
                  >
                    <Flex justifyContent="space-between" marginV={5}>
                      <Flex>
                        <Checkbox
                          disableTouchRipple
                          label="Initial Assessment"
                          labelStyle={muiLabelStyle}
                          checked={
                            this.state.assessmentType === INITIAL_ASSESSMENT
                          }
                          onCheck={() =>
                            this.setState({
                              assessmentType: INITIAL_ASSESSMENT,
                              assessmentTypeError: false
                            })}
                        />
                      </Flex>
                      <Flex justifyContent="flex-end">
                        <Checkbox
                          disableTouchRipple
                          label="Reassessment"
                          labelStyle={muiLabelStyle}
                          style={{ width: "initial" }}
                          checked={this.state.assessmentType === REASSESSMENT}
                          onCheck={() =>
                            this.setState({
                              assessmentType: REASSESSMENT,
                              assessmentTypeError: false
                            })}
                        />
                      </Flex>
                    </Flex>
                  </Popover>
                  <Button xlarge onClick={this.handleNext}>Next</Button>
                  <AccountLinks />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Flex>
    );
  }
}

function mapStateToProps(store) {
  return {
    clientId: store.id,
    clientName: store.name
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setClientInfo: args => dispatch(setClientInfo(args))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Landing);



// WEBPACK FOOTER //
// ./src/containers/Landing/index.jsx